import { RobotOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../auth/store";

const DOCUMENTS = new Set(["expected_receipts", "shipment_orders"]);

/** Whether the button is shown for this card (the grouped panel keeps its row only when there is something in it). */
export function assistantAvailable(entity: string, number: unknown, can: (permission: string) => boolean): boolean {
  return DOCUMENTS.has(entity) && !!number && can("assistant.use");
}

/**
 * «Помочь с этим документом» (ТЗ 13.1): the assistant opens with this document as the working context. UXW-05: the
 * grouped action panel names it «ИИ-помощник» (`label`); the full words stay the tooltip.
 */
export function AssistantDocumentButton({ entity, number, label }: { entity: string; number?: unknown; label?: string }) {
  const can = useAuthStore((s) => s.can);
  const navigate = useNavigate();
  if (!assistantAvailable(entity, number, can)) return null;
  return (
    <Button
      icon={<RobotOutlined />}
      onClick={() => navigate(`/assistant?document=${encodeURIComponent(String(number))}`)}
      data-testid="assistant-document"
      title={label ? "Помочь с этим документом" : undefined}
    >
      {label ?? "Помочь с этим документом"}
    </Button>
  );
}
